import script from "./DrilldownDialog.vue?vue&type=script&lang=ts&setup=true"
export * from "./DrilldownDialog.vue?vue&type=script&lang=ts&setup=true"

import "./DrilldownDialog.vue?vue&type=style&index=0&id=7fc3b634&lang=sass"

const __exports__ = script;

export default __exports__